import { HomePageServices } from "../../../../_services/Arya2.0/HomePageServices";
import { commodityFilterChange } from "../CommonFunctions/Function";
export const buySellData = async (
  type,
  commoditySelected,
  translation = () => null
) => {
  let filter = type;
  if (commoditySelected?.length) {
    let commodityFilter = commodityFilterChange(commoditySelected);
    filter =
      type + `&filters=` + encodeURIComponent(JSON.stringify(commodityFilter));
  }
  let result = await HomePageServices.getAllBuyLeadsDetailsList(
    0,
    5,
    "",
    filter
  );
  let modifiedData = [];
  if (result !== null && result?.data && result?.data?.length) {
    result?.data.forEach((item) => {
      let dataObj = {};
      dataObj.lead_id = item.id;
      dataObj.isBookMarked = item?.is_in_wishlist;
      dataObj.address = item?.address_lang?.toLowerCase();
      dataObj.day = item.buyer_listing_time_ago;
      dataObj.image = item.commodity_image;
      dataObj.rows = [
        item?.commodity_lang?.toLowerCase() +
          (item.variety ? ", " + item.variety : ""),
        item.qty_mt,
        `${translation("Price")} ₹` +
          parseFloat(item.per_mt_price).toLocaleString("en-IN"),
      ];
      dataObj.url =
        "/lead-detail/" +
        item.user_id +
        "/" +
        item.unique_id +
        "?type=" +
        (type === "buy" ? "demand" : "supply");
      modifiedData = [...modifiedData, dataObj];
    });
  }

  return modifiedData;
};
